import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";

const cardData = [
  {
    title: "Vision",
    description:
      "Our goal at Europa Solutions is to be the engine that propels enterprises toward revolutionary growth. By providing creative, affordable, and customized solutions that enable our clients to prosper in the digital age, we hope to transform the consulting industry.",
  },
  {
    title: "Mission",
    description:
      "At Europa Solutions, our aim is to help organizations reach their objectives as profitably and efficiently as possible by offering complete, end-to-end consulting services. We are committed to providing a wide range of services, including digital marketing and web development.",
  },
];

const DirectingOurShip = () => {
  return (
    <Box
      sx={{
        background: "transparent",
        color: "white",
        padding: "40px 20px",
      }}
    >
      <Container>
        <Typography
          variant="body1"
          sx={{
            margin: "0 auto",
            color: "#fff",
            textAlign: "center",
            maxWidth: "800px",
          }}
        >
          Europa Solutions is more than just a startup. We are a
          forward-thinking organization dedicated to assisting businesses in
          their endeavors. With a clear vision and an unwavering commitment to
          excellence, we offer affordable consulting services tailored to the
          unique needs of companies of all sizes.
        </Typography>

        <Box
          sx={{
            backgroundColor: "transparent",
            borderRadius: "12px",
            padding: "30px",
            marginTop: "30px",
            marginX: "auto",
            border: "1px solid #DADFEF80",
            maxWidth: "1200px",
          }}
        >
          <Typography
            sx={{
              fontSize: "25px",
              fontWeight: "bold",
              marginBottom: "20px",
              color: "#DADFEF",
              textAlign: "center",
            }}
          >
            Directing Our Ship
          </Typography>

          <Grid container spacing={3}>
            {cardData.map((card, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <Card
                    sx={{
                      background:
                        "linear-gradient(to bottom, #4d5f70, #2a285b)",
                      color: "white",
                      borderRadius: "10px",
                      position: "relative",
                      zIndex: 1,
                      minHeight: "251px",
                      maxHeight: "536px",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: "inherit",
                        padding: "3px",
                        background: "linear-gradient(90deg, #ffffff, #9D3DBA)",
                        WebkitMask:
                          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                        WebkitMaskComposite: "xor",
                        maskComposite: "exclude",
                      },
                      "&:hover": {
                        background:
                          "linear-gradient(to bottom, #c2bbba, #C42776)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          marginBottom: "10px",
                          color: "#fff",
                        }}
                      >
                        {card.title}
                      </Typography>
                      <Typography sx={{ color: "#fff", fontSize: "16px" }}>
                        {card.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default DirectingOurShip;
